import React, { useContext, useEffect, useState } from 'react'
import { Card, Spin } from 'antd'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import GlobalContext from '../GlobalContext'
import { get } from '../../Common/api'

export default function BoxMap ({ slots, selectedBox }) {
  const { boxes } = useContext(GlobalContext)
  const [cluster, setCluster] = useState([])
  const [loading, setLoading] = useState(false)

  const percent = (value) => {
    return (value / slots.length * 100).toFixed(1)
  }

  const clusterMarker = (cities) => {
    return cities.map((city) => (
      <Marker position={city.coordinates} key={`map_${city.insee_code}`} >
        <Popup>
          <p>{city.normalized_name}</p>
          <p>{`Nb rdv : ${slots.filter(slot => slot.postal_place_id === city.id).length}`}</p>
          <p>{`% rdv : ${slots.length > 0 ? percent(slots.filter(slot => slot.postal_place_id === city.id).length) : 0}`}</p>
        </Popup>
      </Marker>
    ))
  }

  const getCluster = async (id) => {
    setLoading(true)
    await get({
      url: `admin/boxes/${id}/cluster`,
      params: {},
      onSuccess: (json) => {
        setCluster(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getCluster(selectedBox)
  }, [selectedBox])

  const box = boxes.find(box => box.id === selectedBox)

  return (
    <Card>
      <Spin spinning={loading}>
        <MapContainer center={box.coordinates} zoom={10} scrollWheelZoom={true} style={{ height: '500px', width: '550px' }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {clusterMarker(cluster)}
        </MapContainer>
      </Spin>
    </Card>
  )
}
